import { APIMethod, fetchData } from "@client";

export async function setProjectVersionCommentReadStatus(
  commentUuid,
  projectUuid,
  commenterUuid,
  versionKey,
) {
  const res = await fetchData(
    `v1/ws/project/comments/read/${commentUuid}`,
    APIMethod.PUT,
    {
      removeEmptyKeys: true,
      data: {
        uuid: projectUuid,
        user: commenterUuid,
        version: versionKey,
      }
    }
  );
  return res.results;
}